<h1> {{title}} </h1>
<div class="appBody">
    <app-user-summary></app-user-summary>
    <nav>
        <a routerLink="/petitions">Petitions</a>
        <a routerLink="/categories">Categories</a>
        <a *ngIf="!isLoggedIn" routerLink="/login">Login</a>
    </nav>
    <router-outlet></router-outlet>
</div>
<mat-divider></mat-divider>
<app-message-bar></app-message-bar>